import React, { useState } from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import Icon from 'shared/components/vxl/icon/Icon/Icon';
import BodySmBoldText from 'shared/components/vxl/typography/primary/body/BodySmBoldText';
import theme from 'shared/styles/theme';

import AccountActionCardActivation, {
  AccountActionCardActivationProps,
} from './AccountActionCardActivation/AccountActionCardActivation';
import AccountActionItem, {
  AccountActionProps,
} from './AccountActionItem/AccountActionItem';

export interface AccountActionsContainerProps {
  titleText: string;
  actions: (AccountActionProps | AccountActionCardActivationProps)[];
}

const AccountAction = ({
  titleText,
  actions,
}: AccountActionsContainerProps) => {
  const [showActionItems, setShowActionItems] = useState(true);
  return (
    <View style={styles.container}>
      <Pressable
        style={styles.header}
        onPress={() => setShowActionItems(!showActionItems)}
        testID="account-action-header"
      >
        <BodySmBoldText numberOfLines={0}>{titleText}</BodySmBoldText>
        <Icon
          iconKey={showActionItems ? 'CHEVRON_UP' : 'CHEVRON_DOWN'}
          iconSize="SM"
          iconColor={theme.color.text.secondary}
        />
      </Pressable>
      {showActionItems ? (
        <View>
          {actions?.map((item, index) => {
            return (
              <View key={item.id}>
                {index > 0 ? (
                  <View style={styles.divider}>
                    <HairLineDivider />
                  </View>
                ) : null}
                {(item as AccountActionCardActivationProps)
                  ?.cardActivationAction ? (
                  <AccountActionCardActivation
                    {...(item as AccountActionCardActivationProps)}
                  />
                ) : (
                  <AccountActionItem {...(item as AccountActionProps)} />
                )}
              </View>
            );
          })}
        </View>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.interactive.tertiary,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    flexDirection: 'column',
  },
  divider: {
    paddingHorizontal: theme.spacing.m,
  },
  header: {
    flexDirection: 'row',
    gap: 10,
    justifyContent: 'space-between',
    marginBottom: theme.spacing.xs,
    paddingBottom: theme.spacing.xs,
    paddingHorizontal: theme.spacing.m,
    paddingTop: theme.spacing.s,
  },
});

export default AccountAction;
